import React, { useEffect, useState } from "react";
import axios from "axios";
import { uniqBy } from "lodash";
import { useLocation } from "react-router-dom";
import { FieldGroup, LoadingOverlay } from "../../../components";
import { Button } from "../../../components/ui";
import { formatWarrantyDate, WARRANTY_DATE_PLACEHOLDER } from "../../../core/warrantyDate";
import "./client-verify-product.scss";

export function ClientVerifyProduct({ request, onDone }) {
  const location = useLocation();
  const [verificationCode, setVerificationCode] = useState();
  const [serialNumber, setSerialNumber] = useState(request.serial_number || "");
  const [datePurchase, setDatePurchase] = useState(
    request.date_purchase || null
  );
  // Reads through to the transacted listing on the API side, same as
  // serial_number and date_purchase, so re-opening a verified request shows
  // what was captured rather than an empty box. Held as the plain string the
  // user typed — the API re-detects the precision from it.
  const [warranty, setWarranty] = useState(
    formatWarrantyDate(request.warranty_date, request.warranty_date_precision)
  );
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [images, setImages] = useState(
    request.images
      ?.filter((image) => image.pivot.tag === "client_verification")
      ?.map((image) => image.id)
  );

  const handleVerify = async () => {
    // let valid = true;
    // if (!serialNumber) {
    //   setErrors((prev) => ({
    //     ...prev,
    //     serial_number: "Serial number is required",
    //   }));
    //   valid = false;
    // }
    // if (!images.length) {
    //   setErrors((prev) => ({
    //     ...prev,
    //     images: "At least one image is required",
    //   }));
    //   valid = false;
    // }
    // if (!valid) {
    //   return;
    // }

    const data = {
      serial_number: serialNumber,
      date_purchase: datePurchase,
      // Sent exactly as typed. App\Support\WarrantyDate detects the precision
      // from the string and writes listings.warranty_date +
      // warranty_date_precision as a pair, on every request→listing sync path.
      warranty_date: warranty || null,
      verification_code: verificationCode,
      // Once per id: the verify endpoint attaches a row per id it is sent that
      // is new to the request, and copies those onto the listing.
      images: uniqBy(images || [], String),
    };

    if (request.is_stock) {
      onDone(data);
    } else {
      setSubmitting(true);

      await axios.post(`/api/requests/${request.id}/verify`, data);

      setSubmitting(false);
      onDone(data);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setVerificationCode(searchParams.get("verification_code"));
  }, [location]);

  return (
    <div className="client-verify-product">
      <h1>Enter serial number</h1>

      <div className="serial-number">
        <FieldGroup
          noFormik
          placeholder="Serial number"
          name="serial_number"
          type="text"
          required
          value={serialNumber}
          onChange={(e) => {
            setSerialNumber(e.target.value);
            setErrors((prev) => ({ ...prev, serial_number: "" }));
          }}
        />
        {errors.serial_number && (
          <div className="error">{errors.serial_number}</div>
        )}
      </div>

      <div className="serial-number">
        <FieldGroup
          noFormik
          placeholder="Date Of Purchase (DD/MM/YYYY)"
          name="date_purchase"
          dateFormat="dd/MM/yyyy"
          type="date"
          required
          value={datePurchase}
          onChange={(value) => {
            setDatePurchase(value);
            setErrors((prev) => ({ ...prev, datePurchase: "" }));
          }}
        />
        {errors.datePurchase && (
          <div className="error">{errors.datePurchase}</div>
        )}
      </div>

      {/* Directly below Date of Purchase, per the flow's own ordering: when it
          was bought, then how long it is covered for. A plain FieldGroup like
          the two fields above it — the section's own styling now themes all
          three together. */}
      <div className="serial-number">
        <FieldGroup
          noFormik
          placeholder={`Warranty Date (${WARRANTY_DATE_PLACEHOLDER})`}
          name="warranty_date"
          type="text"
          value={warranty}
          onChange={(e) => setWarranty(e.target.value)}
        />
        <div className="warranty-hint">As precise as the warranty card is</div>
      </div>

      <hr />

      <div className="pictures">
        <h4>Upload picture displaying the serial number</h4>
        <FieldGroup
          noFormik
          className={"mt-0"}
          placeholder=""
          name="images"
          type="galleryUpload"
          value={images}
          onChange={(images) => {
            setImages(images);
            setErrors((prev) => ({ ...prev, images: "" }));
          }}
        />
        {errors.images && <div className="error">{errors.images}</div>}
      </div>

      <div className="mt-5 client-verify-product__actions">
        {/* Transactional, not a persistence Save: the POST submits the
            verification for approval ("Sending for approval…"), so it stays
            a button under the auto-save rule's Send exemption. */}
        <Button variant="primary" size="xl" onClick={() => handleVerify()}>
          Save &amp; Proceed
        </Button>
        <div className="client-verify-product__save-note">
          The serial number is also stored on the listing linked to this request.
        </div>
      </div>

      {submitting && (
        <LoadingOverlay type="submitting" text="Sending for approval..." />
      )}
    </div>
  );
}
